import React, { useState } from "react";
import PlayerContext from "./MusicPlayerContext";

const PlayerState = (props: any) => {
    const [playing, setPlaying] =  useState('');

    const play = (trackId: any) => {
      setPlaying(trackId);
    };
    
    const pause = () => {
      setPlaying('')
    };

    const isPlaying = (trackId: any) => {
      return trackId === playing;
    };

    return (
        <PlayerContext.Provider value={{ play, pause, isPlaying }}>
          {props.children}
        </PlayerContext.Provider>
    )
}

export default PlayerState